module.exports = __webpack_public_path__ + "components/country-flag/static/mu-637d506024ea88c18a927ec723e29f50.svg";